import { useState } from "react";
import Modal from "../modal/modal.component";
import { PortalDialogProps } from "@app/services/modal.service";
import VerificationInput from "react-verification-input";
import Button from "../button";
import "./style.scss";
import clsx from "clsx";

interface OtpModalProps {
  qrCodeUrl: string;
}

function OtpModal({
  portalDialogRef,
  portalData,
}: PortalDialogProps<OtpModalProps>) {
  const [code, setCode] = useState("");
  const [isError, setIsError] = useState(false);

  const handleCodeChange = (value: string) => {
    setIsError(false);
    setCode(value);
  };

  const handleVerify = () => {
    if (code.length === 6) {
      portalDialogRef.close({ code });
    } else {
      setIsError(true);
    }
  };

  const handleAutoVerify = (value: string) => {
    portalDialogRef.close({ code: value });
  };

  return (
    <Modal onCancel={portalDialogRef.close}>
      <div className="w-[423px] py-7 px-6">
        <div className="text-black font-semibold text-xl mb-4">
          Two-Factor Authentication
        </div>
        <div>Step 1: Mở ứng dụng Authenticator và quét mã để thêm mã</div>
        <div className="flex justify-center mb-6">
          {!!portalData?.qrCodeUrl && (
            <img
              src={portalData.qrCodeUrl}
              alt="MFA QR Code"
              className="w-48 h-48"
            />
          )}
        </div>
        <div>Step 2: Nhập mã được xuất hiện trong ứng dụng Authenticator</div>
        <div className="mt-2">
          <VerificationInput
            placeholder=""
            value={code}
            onChange={handleCodeChange}
            autoFocus
            classNames={{
              container: "mx-auto",
              character: "character",
              characterInactive: "character--inactive",
              characterSelected: "character--selected",
              characterFilled: "character--filled",
            }}
            onComplete={handleAutoVerify}
          />
          <div
            className={clsx("text-center text-xs error-color hidden mt-1", {
              "!block": !!isError,
            })}
          >
            Vui lòng nhập đủ 6 số
          </div>
        </div>
        <Button
          size="xs"
          label="Verify"
          width={180}
          className="!h-[51px] !leading-[51px]"
          containerClassName="mt-5 mx-auto"
          labelClassName="text-xl"
          onClick={handleVerify}
        />
      </div>
    </Modal>
  );
}

export default OtpModal;
